import React, {useEffect, useState} from 'react'
import useWebSocket, { ReadyState } from 'react-use-websocket';
import Layout from "../components/Layout";
import Hero from "../components/Hero";
import CTABox from "../components/CTABox";
import PrimaryMenu from "../components/PrimaryMenu";
import SubPageNav from "../components/SubPageNav";
import IconList from "../components/IconList";
import ContentSeries from '../components/ContentSeries';

const ContentSectionLanding = ({pageContext: pagePassedContext}) => {
    const [socketUrl, setSocketUrl] = useState('ws://localhost:9999');
    var {
        sendMessage,
        lastMessage,
        readyState,
      } = useWebSocket(socketUrl);
    
    const connectionStatus = {
        [ReadyState.CONNECTING]: 'Connecting',
        [ReadyState.OPEN]: 'Open',
        [ReadyState.CLOSING]: 'Closing',
        [ReadyState.CLOSED]: 'Closed',
        [ReadyState.UNINSTANTIATED]: 'Uninstantiated',
    }[readyState];

    console.log(pagePassedContext)
    const [pageContext, setContext] = useState(pagePassedContext);
    
    // get the data vars we need from the json data
    // this came from http://api.vanarts.com/api/pages
    //let data = pageContext.content.json_data.data;
    let navigation = pageContext.flyoutnav;
    let data = pageContext.content.json_data.data;
    let header = data.header;
    let nav = pageContext.flyoutnav;
    let linkList = data.content.subLinks;
    let actions = data.actions;
    let subcontent = data.subcontent;
    let contentBlocks = data.contentBlocks;
    let heroPosition = (header.coverPosition) ? header.coverPosition : "center"

    // THIS GETS THE SUB NAVIGATION
    const subnavName = data.navigation;

    /**** MOVE TO A FUNCTION FILE  */
    function search(nameKey, myArray){
        for (var i=0; i < myArray.length; i++) {
            if (myArray[i].name === nameKey) {
                return myArray[i];
            }
        }
    }

    let subnav = search(subnavName, navigation).json_data.data.content.subLinks
    
    useEffect(function(){
        fetch("https://api.vanarts.com/pages/"+pageContext.content.id).then(response=>{
            return response.json();
        }).then(function(json){
            setContext(json)
        })
    }, [])

    useEffect(() => {
        if(lastMessage)
        {
            pageContext.content.json_data.data = JSON.parse(lastMessage.data).data
            setContext(pageContext)
        }
      }, [lastMessage]);
    
    return (
        <Layout nav={nav}>
            <Hero image={header.cover} pos={heroPosition}>
                <PrimaryMenu nav={nav}/>
            </Hero>
            
            <div className="poswrapper">
                <SubPageNav title={data.header.title} linksData={subnav} type="subpage">
                </SubPageNav>

                <div className="wide-pad-magic top-content-section">
                    <article className="standard-content">
                        <div className="pad">
                            <div dangerouslySetInnerHTML={{__html: data.content.bodyintro}}/>
                        </div>
                        {
                            linkList[0].name && <IconList links={linkList}/>
                        }
                    </article>
                </div>


                <div style={{"clear":"both"}}>       
                {
                    contentBlocks.sectionTitle && 
                    
                    <ContentSeries 
                        title={contentBlocks.sectionTitle} 
                        content={contentBlocks} 
                        theme={contentBlocks.theme}
                    />
                }
                </div>


                {
                    subcontent[0].content &&
                    <div className="wide-pad-magic">
                        <article className="standard-content">
                            {
                                subcontent.map((content, i)=>(
                                    <div className={content.theme}>
                                        {content.header && <h2 className="contentBlockHeader">{content.header}</h2>}
                                        <div dangerouslySetInnerHTML={{__html: content.content}} className="themeContent pad"/>
                                    </div>
                                ))
                            }
                        </article>
                    </div>
                }

                <div style={{"clear":"both"}}>
                {
                    actions.boxes.map((action, i)=>(
                        <CTABox label={action.ctaText} url={action.url} image={action.image}>
                            <div dangerouslySetInnerHTML={{__html: action.content}} />
                        </CTABox> 
                    ))
                }
                </div>
            </div>
        
            

        </Layout>
    )
}

export default ContentSectionLanding;